// xams-utils
import { check } from '@xams-utils/check-types';

// xams-entities
import { Version } from '@xams-entities/version';

// validation
import * as validate from './validation';
var VersionRange = {
  create: function create(min, max) {
    validate.minMaxTypes(min, max);
    validate.minType(min);
    validate.maxType(max);
    validate.minMaxValues(min, max);
    return {
      min: min,
      max: max
    };
  },
  contains: function contains(versionRange, version) {
    validate.versionRangeType(versionRange);
    validate.versionType(version);
    var min = versionRange.min,
      max = versionRange.max;
    var greatherThanMin = check.null(min) || Version.greaterThan(version, min);
    var lessThanMax = check.null(max) || Version.lessThan(version, max);
    return greatherThanMin && lessThanMax;
  },
  toString: function toString(versionRange) {
    validate.versionRangeType(versionRange);
    var min = versionRange.min,
      max = versionRange.max;
    if (check.null(max)) {
      return "Greater than ".concat(Version.toString(min));
    } else if (check.null(min)) {
      return "Less than ".concat(Version.toString(max));
    } else {
      return "Between ".concat(Version.toString(min), " and ").concat(Version.toString(max));
    }
  },
  is: function is(versionRange) {
    if (!check.object(versionRange)) {
      return false;
    }
    if (check.undefined(versionRange.min) || check.undefined(versionRange.max)) {
      return false;
    }
    if (check.null(versionRange.min) && check.null(versionRange.max)) {
      return false;
    }
    if (!check.null(versionRange.min) && !Version.is(versionRange.min)) {
      return false;
    }
    if (!check.null(versionRange.max) && !Version.is(versionRange.max)) {
      return false;
    }
    // if (check.null(versionRange.min) && !check.assigned(versionRange.max)) {
    //   return false;
    // }
    return true;
  }
};
Object.freeze(VersionRange);
export { VersionRange };